// extracted by mini-css-extract-plugin
export var container = "blog-post-preview-module--container--1USVy";
export var leadMediaThumb = "blog-post-preview-module--leadMediaThumb--3i5AX";
export var blogDetails = "blog-post-preview-module--blogDetails--1D7r_";
export var blogImage = "blog-post-preview-module--blogImage--1VXEX";
export var blogInfo = "blog-post-preview-module--blogInfo--3WuQJ";
export var blogBtn = "blog-post-preview-module--blogBtn--bCuiC";